export enum VerifiedStatusEnum{
  VERIFIED = 'VERIFIED',
  PHONE_VERIFICATION = 'PHONE_VERIFICATION',
  IDENTITY_VERIFICATION = 'IDENTITY_VERIFICATION',
  BANK_CARD_VERIFICATION = 'BANK_CARD_VERIFICATION',
}
